import { safeParseJSON } from '@/utils/safeParseJSON';

const Utils = {
  data() {
    return {
      showModalBanner: false,
    };
  },
  computed: {
    userProfile() {
      const subUser = safeParseJSON("subUser");
      if (subUser) return subUser;
      return this.$store.getters.getProfile;
    },
    userID() {
      const subUser = safeParseJSON("subUser");
      if (subUser) return subUser.id;
      const profile = this.$store.getters.getProfile;
      return profile ? profile.id : null;
    },
    username() {
      const subUser = safeParseJSON("subUser");
      if (subUser) return subUser.username;
      const profile = this.$store.getters.getProfile;
      return profile ? profile.username : null;
    },
    isSeller() {
      const subUser = safeParseJSON("subUser");
      if (subUser) {
        let isSeller = false;
        subUser.roles.forEach(function (role) {
          if (role.name === "Seller") {
            isSeller = true;
            return;
          }
        });
        return isSeller;
      }
      return this.$store.getters.isSeller;
    },
    ambassadorEnabled() {
      const subUser = safeParseJSON("subUser");
      if (subUser) return subUser.ambassador_enabled;
      const profile = this.$store.getters.getProfile;
      return profile ? profile.ambassador_enabled : false;
    },
    ambassadorAcceptedTerms() {
      const subUser = safeParseJSON("subUser");
      if (subUser) return subUser.ambassador_accepted_terms;
      const profile = this.$store.getters.getProfile;
      return profile ? profile.ambassador_accepted_terms : false;
    },
    isValidateAccount() {
      const profile = this.userProfile || {};
      const betaFeatures = profile.beta_features || {};
      const myAccount = betaFeatures.MY_ACCOUNT === true;
      if (!myAccount) return false;
      return !profile.has_sales_permission;
    },
  },
  methods: {
    formatTelWhats(tel) {
      if (tel) {
        if (tel.toString().indexOf("+55") > -1) {
          var tell = tel.replace(/[() -]/g, "");
          if (tell[0] === "+") {
            tell = tell.substring(1);
          }
          return `https://api.whatsapp.com/send?phone=${tell}`;
        } else {
          return `https://api.whatsapp.com/send?phone=55${tel.replace(
            /[() -]/g,
            "",
          )}`;
        }
      }
    },
    percent(num, dec = 2) {
      return Number(num / 100).toLocaleString("pt-BR", {
        style: "percent",
        minimumFractionDigits: dec,
      });
    },
    /**
     * Obtém o ID do usuário: prioriza o computed userID (presente no mixin Utils) e só então o JSON em localStorage.
     * @returns {number|string|null}
     */
    resolveUserIdForApi() {
      const fromMixin = this.userID;
      if (fromMixin != null && fromMixin !== "") {
        return fromMixin;
      }
      const raw = localStorage.getItem("user");
      if (!raw) {
        return null;
      }
      try {
        const parsed = JSON.parse(raw);
        return parsed && parsed.id != null ? parsed.id : null;
      } catch {
        return null;
      }
    },
  },
};

export default Utils;
